// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class FormComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {}
  }

  mount() { 
    // Grab all items from your page template file
    var contactForm = jQuery(this.element),
    gfItem = contactForm.find('.gfid'),
    gfNum = gfItem.attr('data-id'),
    gfId = parseInt(gfNum),
    gfTitle = gfItem.attr('data-title'),
    gfDesc = gfItem.attr('data-descr'),
    gfAjax = gfItem.attr('data-ajax');

    console.log('contactForm', contactForm);
    console.log('gfItem', gfItem);
    console.log('gfNum', gfNum);
    console.log('gfId', gfId);
    console.log('gfTitle', gfTitle);
    console.log('gfDesc', gfDesc);
    console.log('gfAjax', gfAjax);

    if (contactForm.length) {
      jQuery.ajax({
        type: "GET",
        url: ajaxInfo.ajaxurl,
        data: {
          action: 'load_gravity_form',
          formid: gfId,
          formtitle: gfTitle,
          formdescr: gfDesc,
          formajax: gfAjax,
        }
      }).done(function (data) {
        gfItem.html(data);
      });
    }
  }
  
}
